import React from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import routes from "../../Routes/routes";
import { FormattedMessage } from "react-intl";
import { toReadableUrl } from "../../Utilities/urlHelper";

const findRouteName = (url) => {
  var urls = url.split("/");
  const urlOffsetForLocation = 3;
  if (
    urls[urls.length - urlOffsetForLocation] === "studentview" ||
    urls[urls.length - urlOffsetForLocation] === "programmeview" ||
    urls[urls.length - urlOffsetForLocation] === "classview" ||
    urls[urls.length - urlOffsetForLocation] === "teacherview"
  ) {
    return {
      pathName: toReadableUrl(urls[urls.length - 1]),
      useFormatted: false,
    };
  }
  for (let [routePath, routeName] of Object.entries(routes)) {
    const found = matchPath({ path: routePath, end: true }, url);
    if (found) {
      return { pathName: routeName, useFormatted: true };
    }
  }
  return null;
};

const getPaths = (pathname) => {
  const paths = ["/"];
  if (pathname === "/") return paths;

  pathname.split("/").reduce((prev, curr) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({ url, isLast }) => {
  const routeName = findRouteName(url);
  if (routeName) {
    if (routeName.pathName && routeName.useFormatted) {
      return isLast ? (
        <BreadcrumbItem active>
          <FormattedMessage id={routeName.pathName} />
        </BreadcrumbItem>
      ) : (
        <BreadcrumbItem>
          <Link to={url}>
            <FormattedMessage id={routeName.pathName} />
          </Link>
        </BreadcrumbItem>
      );
    } else if (routeName.pathName && !routeName.useFormatted) {
      return isLast ? (
        <BreadcrumbItem active>{routeName.pathName}</BreadcrumbItem>
      ) : (
        <BreadcrumbItem>
          <Link to={url}>{routeName.pathName}</Link>
        </BreadcrumbItem>
      );
    }
  }
  return null;
};

export default function BreadCrumbs() {
  const { pathname } = useLocation();

  if (pathname === "/") return <div />;

  const paths = getPaths(pathname);
  const items = paths.map((path, i) => (
    <BreadcrumbsItem key={i} url={path} isLast={i === paths.length - 1} />
  ));

  return (
    <div>
      <Breadcrumb>{items}</Breadcrumb>
    </div>
  );
}
